(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hla-flooring-match-quiz"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-hla-quiz]');
    roots.forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const questionForm = root.querySelector('[data-quiz-questions]');
      const steps = [...root.querySelectorAll('[data-quiz-step]')];
      const nextButton = root.querySelector('[data-quiz-next]');
      const backButton = root.querySelector('[data-quiz-back]');
      const restartButton = root.querySelector('[data-quiz-restart]');
      const results = root.querySelector('[data-quiz-results]');
      const progress = root.querySelector('[data-quiz-progress]');
      const stepLabel = root.querySelector('[data-quiz-step-label]');
      const validation = root.querySelector('[data-quiz-validation]');
      let currentStep = 0;

      const track = (eventName, parameters = {}) => {
        const payload = { event: eventName, ...parameters };
        window.hlaEventQueue = window.hlaEventQueue || [];
        window.hlaEventQueue.push(payload);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(payload);
        window.dispatchEvent(new CustomEvent(`hardwoodla:${eventName}`, { detail: parameters }));
      };

      const values = () => {
        const answers = {};
        root.querySelectorAll('[data-answer]').forEach((input) => {
          if (input.type !== 'radio' || input.checked) answers[input.dataset.answer] = input.value;
        });
        return answers;
      };

      const showStep = (index) => {
        const update = () => {
          steps.forEach((step, stepIndex) => { step.hidden = stepIndex !== index; });
          currentStep = index;
          backButton.hidden = index === 0;
          nextButton.textContent = index === steps.length - 1 ? root.dataset.resultsLabel || 'See My Matches' : root.dataset.nextLabel || 'Next';
          progress.style.width = `${((index + 1) / steps.length) * 100}%`;
          stepLabel.textContent = `${index + 1} / ${steps.length}`;
          validation.hidden = true;
          steps[index].querySelector('legend')?.focus?.();
        };
        if (document.startViewTransition) document.startViewTransition(update); else update();
        track('quiz_step_view', { quiz_name: 'flooring_match', step_number: index + 1, step_name: steps[index].dataset.field });
      };

      const stepIsValid = () => {
        const fields = [...steps[currentStep].querySelectorAll('input')];
        if (!fields.length) return true;
        if (fields[0].type === 'radio') return fields.some((field) => field.checked);
        return fields.every((field) => !field.required || field.value.trim());
      };

      const selectMatches = (answers) => {
        const chosen = [];
        if (answers.format === 'Herringbone') chosen.push('herringbone');
        if (answers.format === 'Chevron') chosen.push('chevron');
        if (answers.format === 'Wide plank') chosen.push('wide-plank');
        if (answers.format === 'Straight plank' || answers.format === 'Not sure') chosen.push('european-oak');
        if (!chosen.includes('american-oak')) chosen.push('american-oak');
        if (!chosen.includes('european-oak')) chosen.push('european-oak');
        return chosen.slice(0, 3);
      };

      const populateLeadFields = (answers = values(), matches = selectMatches(answers)) => {
        const fields = { '[data-lead-result]': matches.join(', ') };
        Object.entries(fields).forEach(([selector, value]) => {
          const input = root.querySelector(selector);
          if (input) {
            input.value = value;
            input.setAttribute('value', value);
          }
        });
        try {
          window.sessionStorage?.setItem('hla_quiz_answers', JSON.stringify({ answers, matches }));
        } catch (error) {
          /* Storage may be unavailable in private or preview contexts. The form still retains its values. */
        }
        return { answers, matches };
      };

      const showResults = () => {
        const answers = values();
        const matches = selectMatches(answers);
        root.querySelectorAll('[data-match]').forEach((card) => { card.hidden = !matches.includes(card.dataset.match); });
        populateLeadFields(answers, matches);
        questionForm.hidden = true;
        results.hidden = false;
        progress.style.width = '100%';
        stepLabel.textContent = '';
        results.setAttribute('tabindex', '-1');
        results.focus();
        track('quiz_complete', { quiz_name: 'flooring_match', preferred_format: answers.format, project_timeline: answers.timeline, match_group: matches.join('|') });
        track('quiz_result', { quiz_name: 'flooring_match', match_group: matches.join('|') });
      };

      nextButton.addEventListener('click', () => {
        if (!stepIsValid()) {
          validation.hidden = false;
          return;
        }
        if (currentStep < steps.length - 1) showStep(currentStep + 1); else showResults();
      });
      backButton.addEventListener('click', () => { if (currentStep > 0) showStep(currentStep - 1); });
      restartButton.addEventListener('click', () => {
        root.querySelectorAll('[data-answer]').forEach((input) => {
          if (input.type === 'radio' || input.type === 'checkbox') input.checked = false;
          else input.value = '';
        });
        questionForm.hidden = false;
        results.hidden = true;
        showStep(0);
        track('quiz_restart', { quiz_name: 'flooring_match' });
      });
      steps.forEach((step) => step.addEventListener('change', () => {
        validation.hidden = true;
        populateLeadFields();
      }));
      questionForm.addEventListener('input', () => { populateLeadFields(); });
      questionForm.addEventListener('focusin', () => {
        if (root.dataset.started === 'true') return;
        root.dataset.started = 'true';
        track('quiz_start', { quiz_name: 'flooring_match' });
      }, { once: true });
      const leadForm = root.querySelector('#HlaQuizLeadForm');
      leadForm?.addEventListener('focusin', () => {
        const answers = values();
        populateLeadFields(answers, selectMatches(answers));
      });
      leadForm?.addEventListener('submit', () => {
        const answers = values();
        populateLeadFields(answers, selectMatches(answers));
        track('generate_lead', { lead_type: 'flooring_quiz', preferred_format: answers.format, project_timeline: answers.timeline });
      }, { capture: true });
      if (root.querySelector('[data-quiz-success]')) {
        questionForm.hidden = true;
        results.hidden = false;
        track('lead_confirmation_view', { lead_type: 'flooring_quiz' });
      }
      root.dataset.nextLabel = nextButton.textContent;
      root.dataset.resultsLabel = nextButton.getAttribute('data-results-label') || 'See My Matches';
      showStep(0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
